import React from 'react';
import resumeData from '../data/resumeData.json';

const Expertise = ({ data = resumeData.expertise }) => {
  return (
    <section className="o-section t-section">
      <div className="o-section__header-bg t-section__header"></div>
      <div className="o-section__content-bg t-section__content"></div>

      <div className="o-container">
        <div className="o-section__container">
          <header className="o-section__header t-section__header">
            <div className="o-content">
              <h2 className="o-section__heading">{data.heading}</h2>
              <div className="o-content__body o-section__description">{data.description}</div>
            </div>
          </header>

          <div className="o-section__content t-section__content">
            <div className="o-grid">
              {(data.items || []).map((item) => (
                <div className="o-grid__col-sm-6" key={item.id}>
                  <div className="o-media o-media--block o-content expertise-card">
                    <div className="o-media__figure">
                      <div className="c-number t-primary-color">{item.id}</div>
                    </div>
                    <div className="o-media__body o-content__body">
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Expertise;
